import Vue from 'vue'
import axios from 'axios'
import Router from 'vue-router'

import { VERIFY } from '../constants/api'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views - Pages
const Login = () => import('@/views/pages/Login')
const Page404 = () => import('@/views/pages/Page404')

const OrderList = () => import('@/views/pages/report/OrderList')
const TransactionList = () => import('@/views/pages/report/TransactionList')
const CollabRequest = () => import('@/views/pages/report/CollabRequest')

const Color = () => import('@/views/pages/product/Color')
const Occasion = () => import('@/views/pages/product/Occasion')
const ProductList = () => import('@/views/pages/product/mainProduct/ProductList')
const ProductCreate = () => import('@/views/pages/product/mainProduct/CreateProduct')
const ProductUpdate = () => import('@/views/pages/product/mainProduct/UpdateProduct')
const ProductCategory = () => import('@/views/pages/product/ProductCategory')

const City = () => import('@/views/pages/configuration/City')
const AboutUs = () => import('@/views/pages/configuration/AboutUs')
const Tnc = () => import('@/views/pages/configuration/Tnc')
const HomeBanners = () => import('@/views/pages/configuration/HomeBanners')
const HomeShowcase = () => import('@/views/pages/configuration/HomeShowcase')
const Notification = () => import('@/views/pages/configuration/Notification')
const ShowcaseCreate = () => import('@/views/pages/configuration/ShowcaseForm/Insert')
const FeaturedProducts = () => import('@/views/pages/configuration/FeaturedProducts')
const Announcement = () => import('@/views/pages/configuration/Announcement.vue')

Vue.use(Router)

const configRoutes = () => {
  return [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      redirect: '/report/order-list',
    },
    {
      path: '/report',
      name: 'Report',
      redirect: '/report/transaction-list',
      component: TheContainer,
      children: [
        {
          path: 'order-list',
          name: 'Order List',
          component: OrderList
        },
        {
          path: 'transaction-list',
          name: 'Transaction List',
          component: TransactionList
        },
        {
          path: 'collaboration-request',
          name: 'Collaboration Request',
          component: CollabRequest
        },
      ]
    },
    {
      path: '/product',
      name: 'Product',
      redirect: '/product/list',
      component: TheContainer,
      children: [
        {
          path: 'list',
          name: 'Product List',
          component: ProductList
        },
        {
          path: 'category',
          name: 'Category',
          component: ProductCategory
        },
        {
          path: 'color',
          name: 'Color',
          component: Color
        },
        {
          path: 'occasion',
          name: 'Occasion',
          component: Occasion
        },
        {
          path: 'create',
          name: 'Create Product',
          component: ProductCreate
        },
        {
          path: 'update/:id',
          name: 'Update Product',
          component: ProductUpdate
        },
      ]
    },
    {
      path: '/config',
      name: 'Configuration',
      redirect: '/config/notification',
      component: TheContainer,
      children: [
        {
          path: 'notification',
          name: 'Notification',
          component: Notification
        },
        {
          path: 'tnc',
          name: 'Terms & Condition',
          component: Tnc
        },
        {
          path: 'banners',
          name: 'Banners',
          component: HomeBanners
        },
        {
          path: 'showcase',
          name: 'Showcase',
          component: HomeShowcase,
        },
        {
          path: 'create-showcase',
          name: 'Create Showcase',
          component: ShowcaseCreate
        },
        {
          path: 'about-us',
          name: 'About Us',
          component: AboutUs
        },
        {
          path: 'city',
          name: 'City',
          component: City
        },
        {
          path: 'featured-products',
          name: 'Featured Products',
          component: FeaturedProducts
        },
        {
          path: 'announcement',
          name: 'Announcement',
          component: Announcement
        }
      ]
    },
    {
      path: '*',
      name: 'Page404',
      component: Page404,
    }
  ]
}

const router = new Router({
  mode: 'history',
  routes: configRoutes(),
  linkActiveClass: 'active',
  scrollBehavior: (to, from, savedPosition) => {
    if (to.meta.keepScroll && savedPosition) return savedPosition
    else return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const accessToken = sessionStorage.getItem('access_token')
  const headers = {
    headers: {
      'x-access-token': accessToken
    }
  }

  if (!accessToken && to.path !== '/login') {
    next({ path: '/login' })
  } else {
    axios.get(VERIFY, headers)
      .then(() => {
        next()
      })
      .catch(err => {
        if (to.path !== '/login') {
          next({
            path: '/login',
            query: {
              errorMessage: err.response.data.message
            }
          })
        } else {
          next()
        }
      })
  }
})

export default router